const escapeHtml = (value) =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const mimeFromName = (name = '') => {
  const lower = String(name).toLowerCase();
  if (lower.endsWith('.pdf')) return 'application/pdf';
  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
  if (lower.endsWith('.webp')) return 'image/webp';
  if (lower.endsWith('.gif')) return 'image/gif';
  return '';
};

export async function fetchDocumentBlob(url, headers = {}) {
  const response = await fetch(url, { headers });
  if (!response.ok) {
    const message = response.status === 404 ? 'Arquivo não encontrado.' : 'Erro ao carregar documento.';
    throw new Error(message);
  }
  return response.blob();
}

export async function downloadDocument(url, filename, headers = {}) {
  const blob = await fetchDocumentBlob(url, headers);
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename || 'documento';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

export async function previewDocument(url, filename, headers = {}) {
  const viewerWindow = window.open('', '_blank');
  if (!viewerWindow) {
    throw new Error('O navegador bloqueou a nova janela do visualizador.');
  }

  viewerWindow.document.write(`
    <!doctype html>
    <html>
      <head>
        <title>${escapeHtml(filename || 'Documento')}</title>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <style>
          body { margin: 0; background: #0f172a; color: #e2e8f0; font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; }
          header { height: 56px; display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 0 16px; background: #111827; border-bottom: 1px solid rgba(255,255,255,.12); }
          strong { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
          a { color: #fff; background: #2563eb; text-decoration: none; border-radius: 8px; padding: 9px 12px; font-size: 14px; }
          main { height: calc(100vh - 57px); display: grid; place-items: center; }
          .loading { color: #cbd5e1; }
        </style>
      </head>
      <body>
        <header>
          <strong>${escapeHtml(filename || 'Documento')}</strong>
          <a id="downloadLink" href="#">Baixar</a>
        </header>
        <main><div class="loading">Carregando visualizador...</div></main>
      </body>
    </html>
  `);
  viewerWindow.document.close();

  const blob = await fetchDocumentBlob(url, headers);
  const type = blob.type || mimeFromName(filename);
  const objectUrl = URL.createObjectURL(type ? blob.slice(0, blob.size, type) : blob);
  const escapedName = escapeHtml(filename || 'documento');
  const main = viewerWindow.document.querySelector('main');
  const downloadLink = viewerWindow.document.getElementById('downloadLink');

  downloadLink.href = objectUrl;
  downloadLink.download = filename || 'documento';

  if (type.startsWith('image/')) {
    main.innerHTML = `<img src="${objectUrl}" alt="${escapedName}" style="max-width:100%;max-height:100%;object-fit:contain;" />`;
  } else if (type === 'application/pdf' || String(filename || '').toLowerCase().endsWith('.pdf')) {
    main.innerHTML = `<iframe title="${escapedName}" src="${objectUrl}" style="width:100%;height:100%;border:0;background:#fff;"></iframe>`;
  } else {
    main.innerHTML = `
      <div style="max-width:520px;padding:24px;text-align:center;">
        <h1 style="font-size:20px;margin:0 0 8px;">Visualização não disponível</h1>
        <p style="color:#cbd5e1;margin:0;">Este tipo de arquivo não abre no navegador. Use o botão Baixar.</p>
      </div>
    `;
  }

  viewerWindow.addEventListener('beforeunload', () => URL.revokeObjectURL(objectUrl), { once: true });
}
